// src/types/templateCategoryTypes.ts

import { Company } from './companyTypes';

/**
 * Represents the structure of a Company object,
 * often returned as part of other data structures like UserRole or TemplateCategory.
 */

/**
 * Enum for Icon Identifiers.
 * The string values should match how they are represented/serialized from the C# backend.
 * If your C# enum serializes to numbers, these should be numbers.
 * Assuming string serialization based on common practices.
 */
export enum IconIdentifier {
  Medical = 'Medical',
  Education = 'Education',
  Business = 'Business',
  General = 'General'
  // Add any other identifiers from your C# enum here
  // e.g., Technology = 'Technology',
  //       Finance = 'Finance',
}

/**
 * Represents a Template Category entity.
 * This is the main data structure for a template category.
 */
export interface TemplateCategory {
  id: number; // Primary key, integer
  name: string;
  normalizedName: string;
  iconIdentifier: IconIdentifier; // Uses the IconIdentifier enum
  companyId: string; // Guid of the associated company, represented as a string
  company: Company; // Optional navigation property, populated if included in API response
}

/**
 * Input DTO (Data Transfer Object) for creating a new template category.
 * UserId is handled via headers in the service, so it's not part of this client-side DTO.
 */
export interface CreateTemplateCategoryInput {
  name: string;
  iconIdentifier: IconIdentifier;
}

/**
 * Input DTO for updating an existing template category.
 * Fields are optional to allow for partial updates.
 * UserId is handled via headers.
 */
export interface UpdateTemplateCategoryInput {
  id: number; // The ID of the category to update is required to identify it.
  name?: string; // Optional: new name for the category
  iconIdentifier?: IconIdentifier; // Optional: new icon for the category
}
